/* BARRIO — global.js */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) =>
    (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });

  /* ------------------------------------------------ Body scroll lock */
  let lockCount = 0;
  const lockScroll = () => { lockCount++; document.body.style.overflow = 'hidden'; };
  const unlockScroll = () => { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.style.overflow = ''; };

  /* ------------------------------------------------ Header (overlay, scroll-linked fade) */
  function initHeader() {
    const ann = $('.announcement');
    const setAnn = () =>
      document.documentElement.style.setProperty('--announcement-h', (ann ? ann.offsetHeight : 0) + 'px');
    setAnn();
    window.addEventListener('resize', setAnn);
    const header = $('.header--over-hero');
    if (!header) return;
    const mq = window.matchMedia('(max-width: 990px)');
    const FADE = 260; // px of scroll over which the white header fades to transparent
    // With :has() the header rides a sticky wrapper (base.css) and the browser keeps it
    // under the announcement bar; only older browsers need the per-scroll `top`.
    const nativeSticky = window.CSS && CSS.supports && CSS.supports('selector(:has(a))');

    // One header whose white fades with the scroll position (--hdr-scroll:
    // 1 = white, 0 = transparent). White at the top, fades out over the first
    // FADE px while scrolling down, and fades back to white as soon as you
    // scroll up, so menu and cart stay readable over white sections. It used to
    // swap between a solid and a transparent version in one step at 24px, and
    // jump up by the announcement height at the same moment.
    // Homepage (data-clear-top): fully transparent with white text for as long as
    // the hero is behind the header, then the usual behaviour below it.
    const hero = header.hasAttribute('data-clear-top') ? $('main .hero') : null;
    let lastY = window.scrollY;
    let returned = false; // scrolled back up past the fade zone → white
    let ticking = false;
    const update = () => {
      ticking = false;
      const y = Math.max(0, window.scrollY);
      const annH = ann ? ann.offsetHeight : 0;
      if (!nativeSticky) header.style.top = Math.max(0, annH - y) + 'px';   // pinned below the announcement until it scrolls away
      const goingDown = y > lastY + 2;
      const goingUp = y < lastY - 2;
      if (goingDown) returned = false;
      else if (goingUp && y > FADE) returned = true;
      let s = returned ? 1 : 1 - Math.min(1, y / FADE);
      if (hero && hero.getBoundingClientRect().bottom > header.getBoundingClientRect().bottom) s = 0;
      header.style.setProperty('--hdr-scroll', s.toFixed(3));
      if (mq.matches) {
        // Mobile smart header: hides on scroll-down, returns on scroll-up.
        if (y <= 24) header.classList.remove('header--hidden');
        else if (goingDown && y > 260) header.classList.add('header--hidden');
        else if (goingUp) header.classList.remove('header--hidden');
      } else {
        header.classList.remove('header--hidden');
      }
      if (goingDown || goingUp) lastY = y;
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    mq.addEventListener('change', () => { header.style.top = ''; header.classList.remove('header--hidden'); update(); });
  }

  /* ------------------------------------------------ Mobile nav */
  function initMobileNav() {
    const nav = $('#MobileNav');
    const overlay = $('#NavOverlay');
    const openBtn = $('#MobileNavToggle');
    const closeBtn = $('#MobileNavClose');
    if (!nav) return;
    const isOpen = () => nav.classList.contains('is-open');
    const open = () => { if (isOpen()) return; nav.classList.add('is-open'); overlay?.classList.add('is-open'); nav.setAttribute('aria-hidden', 'false'); lockScroll(); };
    // Guarded: Escape fires every close handler on the page, and an unguarded
    // close released the shared scroll lock for whichever panel really was open.
    const close = () => { if (!isOpen()) return; nav.classList.remove('is-open'); overlay?.classList.remove('is-open'); nav.setAttribute('aria-hidden', 'true'); unlockScroll(); };
    openBtn?.addEventListener('click', open);
    closeBtn?.addEventListener('click', close);
    overlay?.addEventListener('click', close);
    $$('.mobile-nav__toggle', nav).forEach((btn) => {
      btn.addEventListener('click', () => {
        const sub = btn.closest('.mobile-nav__item').querySelector('.mobile-nav__sub');
        sub?.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', sub?.classList.contains('is-open'));
      });
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ------------------------------------------------ Accordions */
  function initAccordions() {
    $$('.accordion__trigger').forEach((t) => {
      t.addEventListener('click', () => {
        const panel = t.nextElementSibling;
        const expanded = t.getAttribute('aria-expanded') === 'true';
        t.setAttribute('aria-expanded', String(!expanded));
        panel.style.maxHeight = expanded ? '0px' : panel.scrollHeight + 'px';
      });
    });
    // Panels marked expanded in the markup start open.
    $$('.accordion__trigger[aria-expanded="true"]').forEach((t) => {
      t.nextElementSibling.style.maxHeight = t.nextElementSibling.scrollHeight + 'px';
    });
  }

  /* ------------------------------------------------ Cart drawer */
  const CartDrawer = {
    el: null,
    overlay: null,
    init() {
      this.el = $('#CartDrawer');
      this.overlay = $('#CartOverlay');
      if (!this.el) return;
      this.overlay?.addEventListener('click', () => this.close());
      $('#CartDrawerClose')?.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      // open cart from header when drawer mode
      $$('[data-cart-open]').forEach((b) =>
        b.addEventListener('click', (e) => {
          if (b.dataset.cartOpen === 'drawer') { e.preventDefault(); this.open(); }
        })
      );
      this.el.addEventListener('click', (e) => {
        const rm = e.target.closest('[data-cart-remove]');
        if (rm) { e.preventDefault(); this.change(rm.dataset.line, 0); }
        const inc = e.target.closest('[data-qty-change]');
        if (inc) { e.preventDefault(); this.change(inc.dataset.line, parseInt(inc.dataset.qty, 10)); }
      });
    },
    isOpen() { return !!this.el && this.el.classList.contains('is-open'); },
    open() { if (!this.el || this.isOpen()) return; this.el.classList.add('is-open'); this.overlay?.classList.add('is-open'); this.el.setAttribute('aria-hidden', 'false'); lockScroll(); },
    close() { if (!this.isOpen()) return; this.el.classList.remove('is-open'); this.overlay?.classList.remove('is-open'); this.el.setAttribute('aria-hidden', 'true'); unlockScroll(); },
    async change(line, quantity) {
      try {
        const res = await fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity }),
        });
        if (!res.ok) throw new Error('cart change failed: ' + res.status);
        const cart = await res.json();
        this.render(cart);
        updateCartCount(cart.item_count);
      } catch (err) {
        // Without this the drawer rendered `undefined` over the customer's bag.
        console.error(err);
        this.error();
      }
    },
    // Last resort when the cart can't be read or changed: send them to the real
    // cart page rather than leaving a drawer that lies about what's in it.
    error() {
      const body = $('#CartDrawerBody');
      const foot = $('#CartDrawerFoot');
      if (!body) return;
      const message = (window.cartStrings && window.cartStrings.error) || 'Something went wrong.';
      body.innerHTML =
        '<div class="cart-empty"><p class="eyebrow"></p><a class="btn"></a></div>';
      body.querySelector('.eyebrow').textContent = message;
      const link = body.querySelector('.btn');
      link.textContent = 'Open your bag';
      link.href = (window.routes && window.routes.cart_url) || '/cart';
      if (foot) foot.hidden = true;
    },
    render(cart) {
      const body = $('#CartDrawerBody');
      const foot = $('#CartDrawerFoot');
      if (!body) return;
      if (cart.item_count === 0) {
        body.innerHTML = `<div class="cart-empty"><p class="eyebrow">Your bag is empty</p><a href="/collections/all" class="btn">Shop the drop</a></div>`;
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;
      body.innerHTML = cart.items.map((it, i) => `
        <div class="cart-line">
          <img class="cart-line__img" src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : ''}" alt="" loading="lazy">
          <div>
            <a href="${it.url}" class="cart-line__title">${it.product_title}</a>
            ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${it.variant_title}</div>` : ''}
            <div class="qty" style="margin-top:10px">
              <button data-qty-change data-line="${i + 1}" data-qty="${it.quantity - 1}" aria-label="Decrease">&minus;</button>
              <input value="${it.quantity}" readonly aria-label="Quantity">
              <button data-qty-change data-line="${i + 1}" data-qty="${it.quantity + 1}" aria-label="Increase">&plus;</button>
            </div>
            <button class="cart-line__remove" data-cart-remove data-line="${i + 1}">Remove</button>
          </div>
          <div class="cart-line__price">${money(it.final_line_price)}</div>
        </div>`).join('');
      // Not cart.total_price: /cart/change.js puts the estimated shipping in it
      // (€5 under the threshold), /cart.js doesn't.
      const subtotal = cartSubtotal(cart);
      const sub = $('#CartSubtotal');
      if (sub) sub.textContent = money(subtotal);
      updateShippingBars(subtotal);
    },
    async refresh() {
      const res = await fetch(window.routes.cart_url + '.js');
      if (!res.ok) throw new Error('cart read failed: ' + res.status);
      const cart = await res.json();
      this.render(cart);
      updateCartCount(cart.item_count);
    },
  };

  // Free-shipping bar (snippets/free-shipping-bar.liquid). Thresholds come in
  // shop-currency cents; the UK has its own £ amount, other local currencies
  // are converted with Shopify's rate like the shipping rate itself.
  // `| t` HTML-escapes, so "You're" reaches JS as "You&#39;re".
  const decodeEntities = (str) => {
    const el = document.createElement('textarea');
    el.innerHTML = str || '';
    return el.value;
  };

  function updateShippingBars(totalCents) {
    const strings = window.cartStrings || {};
    const active = window.Shopify?.currency?.active;
    const rate = parseFloat(window.Shopify?.currency?.rate) || 1;
    $$('[data-free-shipping-bar]').forEach((bar) => {
      const total = totalCents ?? parseInt(bar.dataset.total, 10);
      if (Number.isNaN(total)) return;
      bar.dataset.total = total;
      let threshold = parseInt(bar.dataset.threshold, 10);
      if (active === 'GBP') threshold = parseInt(bar.dataset.thresholdGbp, 10);
      else if (active && active !== window.theme?.shopCurrency) threshold = Math.round(threshold * rate);
      if (!threshold) return;
      const remaining = threshold - total;
      const text = bar.querySelector('.ship-bar__text');
      const fill = bar.querySelector('.ship-bar__fill');
      if (text) {
        text.textContent = remaining > 0
          ? decodeEntities(strings.freeShippingRemaining).replace('[amount]', money(remaining))
          : decodeEntities(strings.freeShippingUnlocked);
      }
      if (fill) fill.style.width = Math.min(100, Math.max(0, (total / threshold) * 100)) + '%';
      bar.classList.toggle('is-unlocked', remaining <= 0);
      bar.hidden = false;
    });
  }

  const cartSubtotal = (cart) =>
    cart.items_subtotal_price -
    (cart.cart_level_discount_applications || []).reduce((sum, d) => sum + (d.total_allocated_amount || 0), 0);

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ------------------------------------------------ Add to cart (AJAX) */
  function initAddToCart() {
    $$('form.js-product-form').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        const drawer = $('#CartDrawer');
        if (!drawer) return; // page cart mode -> normal submit
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        const original = btn ? btn.innerHTML : '';
        if (btn) { btn.classList.add('is-loading'); btn.disabled = true; btn.textContent = 'Adding…'; }
        try {
          const res = await fetch(window.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          if (!res.ok) throw new Error('add');
          await CartDrawer.refresh();
          CartDrawer.open();
        } catch (err) {
          form.submit();
        } finally {
          if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; btn.innerHTML = original; }
        }
      });
    });
  }

  /* ------------------------------------------------ Quantity steppers (product page) */
  function initQty() {
    $$('.qty[data-qty-input]').forEach((wrap) => {
      const input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach((b) => {
        b.addEventListener('click', () => {
          const step = b.dataset.step === 'down' ? -1 : 1;
          const val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------ Product variants */
  function initVariants() {
    $$('[data-variant-selector]').forEach((root) => {
      let variants;
      try { variants = JSON.parse($('[data-variant-json]', root).textContent); } catch (e) { return; }
      const optionInputs = () => $$('.variant-input:checked', root);
      const priceEl = $('[data-product-price]', root);
      const priceWasEl = $('[data-product-price-was]', root);
      const idInput = $('[data-variant-id]', root);
      const addBtn = $('[data-add-btn]', root);
      const media = $$('.product__media[data-media-id]');
      const mainImg = $('[data-main-media]');

      function findVariant() {
        const chosen = optionInputs().map((i) => i.value);
        return variants.find((v) => v.options.every((opt, idx) => opt === chosen[idx]));
      }
      function update() {
        const v = findVariant();
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        // price_formatted comes from Liquid's money filter, so the format matches
        // what the page was rendered with. money() is only a fallback.
        if (priceEl) priceEl.textContent = v.price_formatted || money(v.price);
        if (priceWasEl) {
          if (v.compare_at_price > v.price) {
            priceWasEl.textContent = v.compare_at_price_formatted || money(v.compare_at_price);
            priceWasEl.hidden = false;
          }
          else priceWasEl.hidden = true;
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? (addBtn.dataset.label || 'Add to bag') : 'Sold out';
        }
        const soldTag = $('[data-sold-status]', root);
        if (soldTag) {
          soldTag.hidden = v.available;
          if (!v.available) {
            const whole = variants.length === 1 || variants.every((x) => !x.available);
            soldTag.textContent = whole ? 'Sold out' : 'Sold out in ' + v.options.join(' / ');
          }
        }
        if (v.featured_media && mainImg) {
          const target = media.find((m) => m.dataset.mediaId == v.featured_media.id);
          if (target && target.querySelector('img')) mainImg.src = target.querySelector('img').src;
        }
        // update URL
        if (history.replaceState && v.id) {
          const url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url);
        }
      }
      $$('.variant-input', root).forEach((i) => i.addEventListener('change', update));
      update();
    });
  }

  /* ------------------------------------------------ Product scrollers */
  function initScrollers() {
    $$('.product-scroller').forEach((sc) => {
      // mouse drag-to-scroll (touch devices use native swipe)
      let down = false, moved = false, startX = 0, startLeft = 0;
      sc.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = sc.scrollLeft;
      });
      sc.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 6) { moved = true; sc.classList.add('is-dragging'); }
        if (moved) sc.scrollLeft = startLeft - dx;
      });
      const end = () => { down = false; setTimeout(() => sc.classList.remove('is-dragging'), 0); };
      sc.addEventListener('pointerup', end);
      sc.addEventListener('pointerleave', end);
      // suppress the click that follows a drag so cards don't navigate
      sc.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });

    // scroll bar under the carousel: the bar's width is the visible share, its position the scroll progress
    $$('[data-scroller-progress]').forEach((track) => {
      const sec = track.closest('section');
      const sc = sec && sec.querySelector('.product-scroller');
      const bar = track.firstElementChild;
      if (!sc || !bar) return;
      const update = () => {
        const max = sc.scrollWidth - sc.clientWidth;
        track.hidden = max <= 2;
        if (track.hidden) return;
        const ratio = sc.clientWidth / sc.scrollWidth;
        const p = Math.min(1, Math.max(0, sc.scrollLeft / max));
        bar.style.width = ratio * 100 + '%';
        bar.style.transform = `translateX(${p * (1 / ratio - 1) * 100}%)`;
      };
      // click or drag along the line to scroll
      let dragging = false;
      const seek = (e) => {
        const r = track.getBoundingClientRect();
        const barW = bar.getBoundingClientRect().width;
        const p = (e.clientX - r.left - barW / 2) / (r.width - barW);
        sc.scrollLeft = Math.min(1, Math.max(0, p)) * (sc.scrollWidth - sc.clientWidth);
      };
      track.addEventListener('pointerdown', (e) => {
        dragging = true;
        track.setPointerCapture(e.pointerId);
        sc.style.scrollBehavior = 'auto';
        sc.style.scrollSnapType = 'none';
        seek(e);
      });
      track.addEventListener('pointermove', (e) => { if (dragging) seek(e); });
      const stop = () => { dragging = false; sc.style.scrollBehavior = ''; sc.style.scrollSnapType = ''; };
      track.addEventListener('pointerup', stop);
      track.addEventListener('pointercancel', stop);
      sc.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });

    function updateArrows(sc, sec) {
      const max = sc.scrollWidth - sc.clientWidth - 2;
      sec.querySelectorAll('[data-scroll="prev"]').forEach((b) => (b.disabled = sc.scrollLeft <= 2));
      sec.querySelectorAll('[data-scroll="next"]').forEach((b) => (b.disabled = sc.scrollLeft >= max));
    }
    $$('[data-scroll]').forEach((btn) => {
      const sec = btn.closest('section');
      const sc = sec && sec.querySelector('.product-scroller');
      if (!sc) return;
      btn.addEventListener('click', () => {
        const card = sc.querySelector('.card');
        const step = (card ? card.getBoundingClientRect().width : 300) * 2;
        sc.scrollBy({ left: btn.dataset.scroll === 'next' ? step : -step, behavior: 'smooth' });
      });
      sc.addEventListener('scroll', () => updateArrows(sc, sec), { passive: true });
      updateArrows(sc, sec);
    });
  }

  /* ------------------------------------------------ Product gallery thumbs */
  function initGallery() {
    const main = $('[data-main-media]');
    if (!main) return;
    $$('.product__thumb').forEach((t) => {
      t.addEventListener('click', () => {
        const src = t.dataset.full || t.querySelector('img')?.src;
        if (src) main.src = src;
        $$('.product__thumb').forEach((x) => x.classList.remove('is-active'));
        t.classList.add('is-active');
      });
    });
  }

  /* ------------------------------------------------ Product image slider (PDP) */
  function initPdpSlider() {
    const slider = $('[data-pdp-slider]');
    if (!slider) return;
    const track = $('[data-pdp-track]', slider);
    const slides = $$('.pdp-slide', track);
    const total = slides.length;
    if (total <= 1) return;
    const cur = $('[data-pdp-current]', slider);
    const prev = $('[data-pdp="prev"]', slider);
    const next = $('[data-pdp="next"]', slider);
    let i = 0;
    const go = (n) => {
      i = Math.max(0, Math.min(total - 1, n));
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      if (cur) cur.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === total - 1;
    };
    if (prev) prev.addEventListener('click', () => go(i - 1));
    if (next) next.addEventListener('click', () => go(i + 1));
    let sx = 0, sy = 0, down = false;
    slider.addEventListener('pointerdown', (e) => { down = true; sx = e.clientX; sy = e.clientY; });
    slider.addEventListener('pointerup', (e) => {
      if (!down) return; down = false;
      const dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1);
    });
    slider.setAttribute('tabindex', '0');
    slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') go(i + 1);
      else if (e.key === 'ArrowLeft') go(i - 1);
    });
    go(0);
  }

  /* ------------------------------------------------ Card hover gallery (images 3+) */
  function initCardHover() {
    if (window.matchMedia('(hover: none)').matches) return; // touch devices: no hover cycle
    $$('.card').forEach((card) => {
      const shots = $$('.card__img--hover', card);
      if (!shots.length) return;
      let i = -1;
      let timer = null;
      const show = (idx) => shots.forEach((im, k) => im.classList.toggle('is-active', k === idx));
      const start = () => {
        i = 0;
        show(0);
        if (shots.length > 1) {
          timer = setInterval(() => { i = (i + 1) % shots.length; show(i); }, 850);
        }
      };
      const stop = () => {
        clearInterval(timer);
        timer = null;
        i = -1;
        shots.forEach((im) => im.classList.remove('is-active'));
      };
      card.addEventListener('mouseenter', start);
      card.addEventListener('mouseleave', stop);
    });
  }

  /* ------------------------------------------------ Header search dropdown */
  function initHeaderSearch() {
    const wrap = $('[data-header-search]');
    if (!wrap) return;
    const toggle = $('#HeaderSearchToggle', wrap);
    const panel = $('#HeaderSearchPanel', wrap);
    const input = panel && $('.header__search-input', panel);
    if (!toggle || !panel) return;
    const open = () => {
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      if (input) setTimeout(() => input.focus(), 60);
    };
    const close = () => {
      panel.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    };
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      panel.classList.contains('is-open') ? close() : open();
    });
    document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ------------------------------------------------ Predictive search (results as you type) */
  function initPredictiveSearch() {
    const base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    // /products.json always answers in the shop's own currency and ignores
    // markets, so its prices may only be shown when the visitor is being priced
    // in that same currency. Otherwise the typo fallback is skipped rather than
    // labelling euro amounts as dollars.
    const shopCurrency = (window.theme && window.theme.shopCurrency) || currency;
    const catalogUsable = shopCurrency === currency;
    const fmt = (v) => { const n = Number(v); return isNaN(n) ? '' : n.toLocaleString(undefined, { style: 'currency', currency }); };
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const thumb = (url) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=160' : '');
    const T = (window.theme && window.theme.strings) || {};

    /* Normalise text + Levenshtein distance for typo tolerance */
    const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    const lev = (a, b) => {
      const m = a.length, n = b.length;
      if (!m) return n; if (!n) return m;
      let prev = Array.from({ length: n + 1 }, (_, i) => i), cur = new Array(n + 1);
      for (let i = 1; i <= m; i++) {
        cur[0] = i;
        for (let j = 1; j <= n; j++) {
          const cost = a[i - 1] === b[j - 1] ? 0 : 1;
          cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        }
        const tmp = prev; prev = cur; cur = tmp;
      }
      return prev[n];
    };

    /* Barrio Access: a guest sees locked drops marked, like the product cards do.
       Early-access drops carry the tag `barrio-locked` until release (set by the
       app's drop cron); members-only drops carry `zone-only`. Neither the
       predictive API nor /products.json exposes the rank metafield, so the tags
       are what the search bar goes on. Logged-in members get no mark here: their
       rank decides, and the product page itself still locks below it. */
    const loggedIn = !!(window.theme && window.theme.loggedIn);
    const tagList = (p) => {
      const t = p.tags;
      return (Array.isArray(t) ? t : String(t || '').split(',')).map((x) => String(x).trim().toLowerCase());
    };
    /* Backroom pieces (tag `backrooms`) only live in The Backroom, never in search. */
    const notBackroom = (p) => !tagList(p).includes('backrooms');
    const lockLabel = (p) => {
      if (loggedIn) return '';
      const list = tagList(p);
      if (list.includes('barrio-locked')) return T.earlyAccess || 'Early access';
      if (list.includes('zone-only')) return T.membersOnly || 'Members only';
      return '';
    };
    const lockIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';

    /* Whole catalog, fetched once, used as a typo-tolerant fallback */
    let catalog = null, catalogPromise = null;
    const loadCatalog = () => {
      if (catalog) return Promise.resolve(catalog);
      if (catalogPromise) return catalogPromise;
      catalogPromise = fetch('/products.json?limit=250', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : { products: [] }))
        .then((d) => {
          catalog = (d.products || []).filter(notBackroom).map((p) => {
            const prices = (p.variants || []).map((v) => Number(v.price)).filter((n) => !isNaN(n));
            const compares = (p.variants || []).map((v) => Number(v.compare_at_price)).filter((n) => !isNaN(n));
            const words = Array.from(new Set(norm([p.title, p.product_type, p.vendor, (p.tags || []).join(' ')].join(' ')).split(' ').filter(Boolean)));
            return {
              title: p.title, url: '/products/' + p.handle,
              image: (p.images && p.images[0] && p.images[0].src) || '',
              price: prices.length ? Math.min.apply(null, prices) : 0,
              compareAt: compares.length ? Math.max.apply(null, compares) : 0,
              lock: lockLabel(p),
              words
            };
          });
          return catalog;
        })
        .catch(() => { catalog = []; return catalog; });
      return catalogPromise;
    };

    const fuzzy = (q) => {
      if (!catalog || !catalog.length) return [];
      const tokens = norm(q).split(' ').filter((t) => t.length >= 2);
      if (!tokens.length) return [];
      const scored = [];
      catalog.forEach((p) => {
        let total = 0, ok = true;
        for (const t of tokens) {
          let best = 0;
          for (const w of p.words) {
            let s = 0;
            if (w === t || w.startsWith(t)) s = 3;
            else if (w.includes(t)) s = 2;
            else {
              const allowed = t.length <= 4 ? 1 : t.length <= 7 ? 2 : 3;
              const d = lev(t, w);
              if (d <= allowed) s = 1.6 - d / (allowed + 1);
            }
            if (s > best) best = s;
          }
          if (best === 0) { ok = false; break; }
          total += best;
        }
        if (ok) scored.push({ p, total });
      });
      scored.sort((a, b) => b.total - a.total);
      return scored.slice(0, 6).map((x) => x.p);
    };

    /* Normalise either source (predictive API / catalog) into one render shape */
    const fromApi = (p) => ({ title: p.title, url: p.url, image: (p.featured_image && p.featured_image.url) || p.image, price: Number(p.price_min || p.price), compareAt: Number(p.compare_at_price_min || 0), lock: lockLabel(p) });

    $$('[data-predictive-search]').forEach((scope) => {
      const input = $('input[type="search"]', scope);
      const results = $('[data-search-results]', scope);
      if (!input || !results) return;
      let controller = null, timer = null, lastQ = '';

      const hide = () => { results.hidden = true; };

      const render = (items, q, suggested) => {
        if (!items.length) {
          results.innerHTML = '<p class="search-results__empty">' + esc(T.noMatches || 'No matches found.') + '</p>';
          results.hidden = false;
          return;
        }
        const rows = items.map((it) => {
          const img = thumb(it.image);
          const onSale = Number(it.compareAt) > Number(it.price);
          const price = onSale
            ? '<span class="price price--sale"><span class="price__sale">' + fmt(it.price) + '</span><s class="price__was">' + fmt(it.compareAt) + '</s></span>'
            : '<span class="price"><span class="price__regular">' + fmt(it.price) + '</span></span>';
          const lock = it.lock
            ? '<span class="search-result__lock">' + lockIcon + esc(it.lock) + '</span>'
            : '';
          return '<a class="search-result' + (it.lock ? ' search-result--locked' : '') + '" href="' + esc(it.url) + '">' +
            '<span class="search-result__media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
            (it.lock ? '<span class="search-result__dim">' + lockIcon + '</span>' : '') + '</span>' +
            '<span class="search-result__info"><span class="search-result__title">' + esc(it.title) + '</span>' +
            lock + price + '</span></a>';
        }).join('');
        const head = suggested ? '<p class="search-results__hint">' + esc(T.didYouMean || 'Did you mean…') + '</p>' : '';
        results.innerHTML = head + rows + '<a class="search-result--all" href="/search?q=' + encodeURIComponent(q) + '">' + esc(T.viewAll || 'View all results') + '</a>';
        results.hidden = false;
      };

      const run = async (q) => {
        if (controller) controller.abort();
        controller = new AbortController();
        try {
          const res = await fetch(base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last', { signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!res.ok) return hide();
          const data = await res.json();
          const products = ((((data.resources || {}).results || {}).products) || []).filter(notBackroom).slice(0, 6);
          if (products.length) { render(products.map(fromApi), q, false); return; }
          /* No exact matches → typo-tolerant fallback against the catalog */
          if (!catalogUsable) { render([], q, false); return; }
          await loadCatalog();
          render(fuzzy(q), q, true);
        } catch (e) { if (e.name !== 'AbortError') hide(); }
      };

      input.setAttribute('autocomplete', 'off');
      input.addEventListener('input', () => {
        const q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { lastQ = ''; hide(); return; }
        if (q === lastQ) return;
        lastQ = q;
        timer = setTimeout(() => run(q), 200);
      });
      // No catalog preload on focus: it is a ~250-product download that most
      // searches never need, since the predictive API answers first.
      input.addEventListener('focus', () => { if (input.value.trim().length >= 2 && results.innerHTML) results.hidden = false; });
    });
  }

  /* ------------------------------------------------ Access popup */
  function initAccessPopup() {
    const modal = $('#AccessPopup');
    if (!modal) return;
    const overlay = $('#AccessPopupOverlay');
    const KEY = 'barrio_access_popup_seen_at';
    const designMode = !!(window.Shopify && window.Shopify.designMode);

    // Reappear after this many hours. Within that window (same visit, browsing
    // multiple pages, or a quick return) the popup stays hidden; after it, it shows again.
    const reappearMs = Math.max(0, parseFloat(modal.dataset.reappear || '6')) * 3600 * 1000;
    if (!designMode) {
      try {
        const seenAt = parseInt(localStorage.getItem(KEY) || '0', 10);
        if (seenAt && (Date.now() - seenAt) < reappearMs) return;
      } catch (e) {}
    }

    // Record the moment it's shown, so it won't re-pop while the visitor keeps browsing.
    const remember = () => { if (designMode) return; try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} };
    const delay = Math.max(0, parseFloat(modal.dataset.delay || '10')) * 1000;
    let opened = false;

    const open = () => {
      opened = true;
      remember();
      modal.hidden = false;
      if (overlay) overlay.hidden = false;
      requestAnimationFrame(() => {
        modal.classList.add('is-open');
        overlay && overlay.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        lockScroll();
      });
    };
    const close = () => {
      if (!opened) return;
      opened = false;
      modal.classList.remove('is-open');
      overlay && overlay.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();
      remember();
    };

    $('#AccessPopupClose')?.addEventListener('click', close);
    overlay?.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    // Following the sign-up / log-in links counts as engaging — don't nag on return.
    modal.querySelectorAll('a').forEach((a) => a.addEventListener('click', remember));

    // Don't collide with the Shopify cookie-consent banner. On mobile it renders on top
    // (z-index ~2,000,000, well above this popup) and covers the popup's buttons, so taps
    // land on the consent layer instead. The countdown runs from page load when there is no
    // banner, and restarts from the visitor's choice when there is one: Shopify fires
    // `visitorConsentCollected` on choice. The banner can render after this runs, so the
    // check happens when the countdown ends, not up front.
    const consentVisible = () => {
      const el = document.querySelector('#shopify-pc__banner, #shopify-pc__prefs');
      if (!el) return false;
      const r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
    };
    const openWhenClear = () => {
      if (opened || consentVisible()) return;
      open();
    };
    let countdown;
    const startCountdown = (ms) => { clearTimeout(countdown); countdown = setTimeout(openWhenClear, ms); };

    // At least 500 ms after the choice, so the banner has animated away.
    document.addEventListener('visitorConsentCollected', () => startCountdown(Math.max(delay, 500)), { once: true });
    startCountdown(delay);
  }

  /* ------------------------------------------------ Background videos */
  // Muted background videos (hero, The Backroom). iOS Low Power Mode, Safari's
  // "never auto-play" setting and data savers block autoplay; the browser then
  // showed a dark frame with its own play button. The poster stays visible
  // instead (native button hidden in CSS), and we retry on the first tap/scroll.
  function initBgVideos() {
    const videos = Array.from(document.querySelectorAll('video[data-bg-video]'));
    if (!videos.length) return;

    // The video stays invisible (CSS) until it really plays; the poster <img> shows until then.
    videos.forEach((video) => {
      const start = parseFloat(video.dataset.bgStart);
      if (start > 0) {
        const seek = () => { if (video.duration > start) video.currentTime = start; };
        if (video.readyState >= 1) seek();
        else video.addEventListener('loadedmetadata', seek, { once: true });
      }
      const show = () => video.classList.add('is-playing');
      video.addEventListener('playing', show);
      if (!video.paused && video.readyState > 2) show();
    });

    const tryPlay = (video) => {
      if (video._bgTrying) return;
      video.muted = true;
      video.setAttribute('muted', '');
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        video._bgTrying = true;
        attempt.then(() => video.classList.remove('is-blocked'))
          .catch(() => video.classList.add('is-blocked'))
          .finally(() => { video._bgTrying = false; });
      }
    };

    videos.forEach(tryPlay);

    // Keep retrying on every interaction until all videos play: a scroll isn't a user
    // gesture for iOS, so a single retry on the first scroll would be wasted.
    const events = ['touchstart', 'touchend', 'click', 'scroll'];
    const retry = () => {
      const paused = videos.filter((v) => v.paused);
      if (!paused.length) {
        events.forEach((evt) => window.removeEventListener(evt, retry));
        return;
      }
      paused.forEach(tryPlay);
    };
    events.forEach((evt) => window.addEventListener(evt, retry, { passive: true }));

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) videos.filter((v) => v.paused).forEach(tryPlay);
    });
  }

  /* ------------------------------------------------ Init */
  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initMobileNav();
    initAccordions();
    CartDrawer.init();
    initAddToCart();
    initQty();
    initVariants();
    initGallery();
    initPdpSlider();
    initScrollers();
    initCardHover();
    initHeaderSearch();
    initPredictiveSearch();
    initAccessPopup();
    initBgVideos();
    updateShippingBars();
  });

  window.BarrioCart = CartDrawer;
})();
